import { render, staticRenderFns } from "./HeaderInformationNavigationT4a.vue?vue&type=template&id=3435e972&scoped=true"
import script from "./HeaderInformationNavigationT4a.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationT4a.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationT4a.vue?vue&type=style&index=0&id=3435e972&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3435e972",
  null
  
)

export default component.exports